import { useRef } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

import yhmc from "../../assets/yhmc.jpg";
import cab from "../../assets/cab.jpg";
import interwood from "../../assets/interwood.jpg";
import risl from "../../assets/risl.jpg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

function Successstories() {
  const swiperRef = useRef(null);

  return (
    <section>
      <div>
        <h2
          style={{
            color: "black",
            textAlign: "center",
            paddingBottom: "20px",
          }}
        >
          Our Business Alliances
        </h2>

        <p style={{ textAlign: "center", marginBottom: "40px" }}>
          We collaborate with leading technology providers and industry partners
          to bring innovative, reliable solutions that deliver measurable results.
        </p>

        <div
          className="position-relative"
          style={{ position: "relative", display: "flex" }}
        >
          {/* LEFT ARROW */}
          <div className="position-absolute h-100 left-0 top-0 d-flex align-items-center px-2 z-2">
            <div
              onClick={() => swiperRef.current?.slidePrev()}
              className="carousel-nav-btn d-flex justify-content-center align-items-center"
            >
              <BsChevronLeft color="#000" size={20} />
            </div>
          </div>

          {/* RIGHT ARROW */}
          <div className="position-absolute h-100 right-0 top-0 d-flex align-items-center px-2 z-2">
            <div
              onClick={() => swiperRef.current?.slideNext()}
              className="carousel-nav-btn d-flex justify-content-center align-items-center"
            >
              <BsChevronRight color="#000" size={20} />
            </div>
          </div>

          <Swiper
            modules={[Navigation, Autoplay]}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 3000 }}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
          >
            {/* SLIDE 1 */}
            <SwiperSlide>
              <div className="success-story-slide1 position-relative">
                <div className="container h-100 d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={yhmc}
                    alt="YHMC Alliance"
                    style={{
                      height: "120px",
                      width: "350px",
                      marginBottom: "30px",
                      borderRadius: "8px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </SwiperSlide>

            {/* SLIDE 2 */}
            <SwiperSlide>
              <div className="success-story-slide1 position-relative">
                <div className="container h-100 d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={cab}
                    alt="CAB Alliance"
                    style={{
                      height: "120px",
                      width: "350px",
                      marginBottom: "30px",
                      borderRadius: "8px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </SwiperSlide>

            {/* SLIDE 3 */}
            <SwiperSlide>
              <div className="success-story-slide1 position-relative">
                <div className="container h-100 d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={interwood}
                    alt="Interwood Alliance"
                    style={{
                      height: "120px",
                      width: "350px",
                      marginBottom: "30px",
                      borderRadius: "8px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </SwiperSlide>

            {/* SLIDE 4 */}
            <SwiperSlide>
              <div className="success-story-slide1 position-relative">
                <div className="container h-100 d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={risl}
                    alt="RISL Alliance"
                    style={{
                      height: "120px",
                      width: "450px",
                      marginBottom: "30px",
                      borderRadius: "8px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Successstories;
